import { AlertTriangle } from 'lucide-react';
import { Button } from './Button.jsx';
import { Modal } from './Modal.jsx';
import { Text } from './Text.jsx';
import { cn } from '../lib/cn.js';

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'default',
  onCancel,
  onConfirm,
}) {
  const isDanger = tone === 'danger';

  return (
    <Modal open={open} onClose={onCancel} size="sm" ariaLabel={title}>
      <div className="flex items-start gap-3 sm:gap-4">
        <div
          className={
            isDanger
              ? 'mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-pill bg-bad/10 text-bad sm:h-10 sm:w-10'
              : 'mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-pill bg-teal-soft text-teal-dark sm:h-10 sm:w-10'
          }
        >
          <AlertTriangle aria-hidden size={20} strokeWidth={2} />
        </div>
        <div className="min-w-0 flex-1">
          <Text variant="h3" className="mb-2 text-xl leading-tight sm:text-[22px]">
            {title}
          </Text>
          {description && (
            <p className="m-0 text-sm leading-6 text-muted">
              {description}
            </p>
          )}
        </div>
      </div>

      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <Button variant="secondary" onClick={onCancel} className="w-full sm:w-auto">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          className={cn(
            'w-full sm:w-auto',
            isDanger ? 'border-bad bg-bad text-white hover:border-ink hover:bg-ink hover:text-paper' : undefined,
          )}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
